"use strict";

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * An abstract handler for GraphQL directives.
 */

var DirectiveNodeHandlerAdapter =
/*#__PURE__*/
function () {
  function DirectiveNodeHandlerAdapter(targetKind, util, settings) {
    _classCallCheck(this, DirectiveNodeHandlerAdapter);

    this.targetKind = targetKind;
    this.util = util;
    this.settings = settings;
  }
  /**
   * Get the value of the 'if' argument in a directive.
   * @param {DirectiveNode} directive A directive.
   * @param {IConvertContext} convertContext A convert context.
   * @return {Term} The term.
   */


  _createClass(DirectiveNodeHandlerAdapter, [{
    key: "getDirectiveConditionalValue",
    value: function getDirectiveConditionalValue(directive, convertContext) {
      var arg = this.util.getArgument(directive.arguments, 'if');

      if (!arg) {
        throw new Error("The directive ".concat(directive.name.value, " is missing an if-argument."));
      }

      var subValue = this.util.handleNodeValue(arg.value, arg.name.value, convertContext);

      if (subValue.terms.length !== 1) {
        throw new Error("Can not apply the directive ".concat(directive.name.value, " with a list."));
      }

      return subValue.terms[0];
    }
    /**
     * If a `scope: all` directive param is present.
     * @param {DirectiveNode} directive A directive.
     * @return {boolean} If `scope: all` is present.
     */

  }, {
    key: "isDirectiveScopeAll",
    value: function isDirectiveScopeAll(directive) {
      var scopeArg = this.util.getArgument(directive.arguments, 'scope');
      return scopeArg && scopeArg.value.kind === 'EnumValue' && scopeArg.value.value === 'all';
    }
  }]);

  return DirectiveNodeHandlerAdapter;
}();

exports.DirectiveNodeHandlerAdapter = DirectiveNodeHandlerAdapter;